import { getCookie } from "../utils/utils";

export default class Cookies {
	constructor() {
		const rejectButton = document.querySelector(".btn--reject");
		const acceptButton = document.querySelector(".btn--accept");

		rejectButton && rejectButton.addEventListener("click", function () {
			// Cookies rejected - hide banner and specify rejection
			document.getElementsByClassName("cookie-banner")[0].classList.add("cookie-banner--close");
			document.cookie = "consent=false; expires=Thu, 18 Dec 2099 12:00:00 UTC; path=/";
			window.app.smoothScroll.lenis && window.app.smoothScroll.lenis.start()
		})

		acceptButton && acceptButton.addEventListener("click", function () {
			// Cookies accepted - hide banner and specify acception
			document.getElementsByClassName("cookie-banner")[0].classList.add("cookie-banner--close");
			document.cookie = "consent=true; expires=Thu, 18 Dec 2099 12:00:00 UTC; path=/";
			window.app.smoothScroll.lenis && window.app.smoothScroll.lenis.start()
		})

		const consentCookie = getCookie('consent')

		if(consentCookie) {
			// Storage already set, hide banner
			document.getElementsByClassName("cookie-banner")[0].classList.add("cookie-banner--close");
		} else {
			// Storage not set, stop scroll
			window.app.smoothScroll.lenis && window.app.smoothScroll.lenis.stop()
		}
	}
}